export default __webpack_public_path__ + "static/media/commerce.90bedf30.jpg";